
export const LOAD_PERMISSION_DATA_IN_PROGRESS = "LOAD_PERMISSION_DATA_IN_PROGRESS";
export const loadPermissionDataInProgress = () => ({
  type: LOAD_PERMISSION_DATA_IN_PROGRESS,
});

export const LOAD_ROLE_ADMIN_DATA_SUCCESS = "LOAD_ROLE_ADMIN_DATA_SUCCESS";
export const loadRoleAdminDataSuccess = (data) => ({
  type: LOAD_ROLE_ADMIN_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_PERMISSION_DATA_FAILURE = "LOAD_PERMISSION_DATA_FAILURE";
export const loadPermissionDataFailure = () => ({
  type: LOAD_PERMISSION_DATA_FAILURE,
});

export const LOAD_ROLE_PERMISSIONS_DATA_SUCCESS = "LOAD_ROLE_PERMISSIONS_DATA_SUCCESS";
export const loadRolePermissionsDataSuccess = (data) => ({
  type: LOAD_ROLE_PERMISSIONS_DATA_SUCCESS,
  payload: { data },
});


export const LOAD_PERMISSIONS_DATA_SUCCESS = "LOAD_PERMISSIONS_DATA_SUCCESS";
export const loadPermissionsDataSuccess = (data) => ({
  type: LOAD_PERMISSIONS_DATA_SUCCESS,
  payload: { data },
});

export const PERMISSIONS_OPERATION_COMPLETED = "PERMISSIONS_OPERATION_COMPLETED";
export const permissionsOperationCompleted = () => ({
  type: PERMISSIONS_OPERATION_COMPLETED,
});


